module.exports = __webpack_public_path__ + "img/icon-video.d32dfb2d.png";